import React, { useState, useEffect } from 'react';

const SYSTEM_HOST = 'system.justvitalityclinic.com';
const SYSTEM_PATHS = [
  '/login',
  '/activate-account',
  '/reset-password',
  '/account-security',
  '/kiosk',
  '/launcher',
  '/staff',
  '/messages',
  '/analytics',
  '/bookings',
  '/settings',
  '/admin',
];

const isSystemScreen = () => {
  if (typeof window === 'undefined') return false;
  const hostname = String(window.location.hostname || '').toLowerCase();
  const pathname = String(window.location.pathname || '/');
  if (hostname === SYSTEM_HOST) return true;
  return SYSTEM_PATHS.some(path => pathname === path || pathname.startsWith(`${path}/`));
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isSystemScreen()) return;
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  if (isSystemScreen() || !visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4 bg-[#1a0e06]/95 backdrop-blur-xl border-t border-[#C9A96E]/20">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center gap-4">
        <div className="flex-1 text-sm">
          <p className="font-semibold text-white mb-1">We value your privacy</p>
          <p className="text-[#C4A882]">We use cookies for ads personalisation and other technologies to personalise your experience, perform marketing, and collect analytics. Learn more in our <a href="/privacy" className="text-[#C9A96E] underline">Privacy Policy</a>.</p>
        </div>
        <div className="flex gap-3 flex-shrink-0">
          <button onClick={decline} className="px-4 py-2 rounded-lg border border-[#C9A96E]/30 text-[#C4A882] text-sm hover:border-[#C9A96E] transition-colors">Decline</button>
          <button onClick={accept} className="px-6 py-2 rounded-lg bg-gradient-to-r from-[#C9A96E] to-[#B89A5E] text-[#1a0e06] font-semibold text-sm hover:shadow-[0_0_15px_rgba(201,169,110,0.4)] transition-all">Accept All</button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
